import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { ReactComponent as ArrowUpRight } from 'images/icons/arrow_up_right.svg'
import { ReactComponent as MapPinMobile } from 'images/icons/map-pin-mobile.svg';
import { ReactComponent as MapPin } from 'images/icons/map-pin.svg';
import { remCalc } from 'utils/remCalc';

const getPinClassName = ({ variant, isActive, isHover }, shrink) => {
	const classes = ['neighborhoodsMap__pin'];

	if (variant) {
		classes.push(`neighborhoodsMap__pin--${variant.replace(/_/g, '-')}`);
	}

	if (shrink) {
		classes.push('neighborhoodsMap__pin--shrink');
	}

	if (isHover) {
		classes.push('neighborhoodsMap__pin--hover');
	}

	if (isActive) {
		classes.push('neighborhoodsMap__pin--active');
	}

	return classes.join(' ');
};

const Pin = ({
	variant,
	children,
	'aria-label': ariaLabel = 'Map Pin',
	ghost,
	isActive,
	isHover,
	shrink,
	...props
}) => {
	const hasCustomContent = React.Children.count(children) > 0;

	return (
		<Button
			className={getPinClassName({ variant, isActive, isHover }, shrink)}
			component={ghost ? 'span' : undefined}
			aria-label={ariaLabel}
			{...props}
		>
			{hasCustomContent ? children : (
				((isActive || isHover) && !variant?.includes('map')) ? (
					<SvgIcon
						component={ArrowUpRight}
						inheritViewBox
						sx={{
							width: remCalc(15),
							height: remCalc(20),
							pointerEvents: 'none',
						}}
					/>
				) : (
					<>
						<SvgIcon
							component={MapPinMobile}
							inheritViewBox
							sx={{
								display: { xs: 'block', md: 'none' },
								width: remCalc(26),
								height: remCalc(26),
								pointerEvents: 'none',
							}}
						/>
						<SvgIcon
							component={MapPin}
							inheritViewBox
							sx={{
								display: { xs: 'none', md: 'block' },
								width: remCalc(25),
								height: remCalc(25),
								pointerEvents: 'none',
							}}
						/>
					</>
				)
			)}
		</Button>
	);
};

export default Pin;